import { useTranslation } from "react-i18next";
import { Button, focusRing } from "../../ui/index.js";

/**
 * Кнопки внизу шага: «Назад» и «Далее» (или своя подпись), плюс «Пропустить» для необязательных шагов.
 * «Пропустить» нарочно не похожа на кнопку: подчёркнутый серый текст, на широком экране справа от кнопок.
 */
export function StepNav({
  onBack,
  onNext,
  onSkip,
  nextLabel,
  disabled,
  busy,
}: {
  onBack?: () => void;
  onNext: () => void;
  onSkip?: () => void;
  nextLabel?: string;
  disabled?: boolean;
  busy?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div className="mt-6 space-y-2 lg:flex lg:items-center lg:gap-2 lg:space-y-0">
      <div className="flex gap-2">
        {onBack && (
          <Button variant="secondary" onClick={onBack} disabled={busy}>
            {t("common.back")}
          </Button>
        )}
        <Button className="flex-1 lg:flex-none lg:px-8" onClick={onNext} disabled={disabled || busy}>
          {busy ? t("common.loading") : (nextLabel ?? t("onb.next"))}
        </Button>
      </div>
      {onSkip && (
        <button
          type="button"
          className={`block w-full rounded-md py-2 text-center text-sm text-ink-3 underline underline-offset-4 hover:text-ink disabled:opacity-50 lg:ml-4 lg:w-auto ${focusRing}`}
          onClick={onSkip}
          disabled={busy}
        >
          {t("onb.skip")}
        </button>
      )}
    </div>
  );
}
